'use strict';

(function () {
    'use strict';

    appRun.$inject = ['routerHelper'];
    angular.module('app.api').run(appRun);

    function appRun(routerHelper) {
        'ngInject';

        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [{
            state: 'api',
            config: {
                url: '/api',
                component: 'apiIndex'
            }
        }, {
            state: 'open-data-middleware',
            config: {
                url: '/open-data-middleware',
                component: 'openApiViewer',
                params: {
                    title: '.Open data middleware API',
                    jsonPath: '/data/open-data-api.json'
                }
            }
        }, {
            state: 'datasets',
            config: {
                url: '/datasets',
                component: 'openApiViewer',
                params: {
                    title: '.Datasets API',
                    jsonPath: '/data/ckan-api.json'
                }
            }
        }];
    }
})();